module.exports = __webpack_public_path__ + "img/login-bg.a26b1298.png";